import { hiringManagerJobsConstants } from "../../_constants";

const initialState = {};

//delete job reducer
export const create_job_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.CREATE_JOB_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.CREATE_JOB_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case hiringManagerJobsConstants.CREATE_JOB_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//update job reducer
export const update_job_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.UPDATE_JOB_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.UPDATE_JOB_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case hiringManagerJobsConstants.UPDATE_JOB_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//delete job reducer
export const delete_job_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.DELETE_JOB_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.DELETE_JOB_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case hiringManagerJobsConstants.DELETE_JOB_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//all jobs reducer
export const get_jobs_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        jobsPostedData: action.payload,
      };
    case hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//job details reducer
export const get_job_details_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        jobDetailsData: action.payload,
        // data: action.payload
      };
    case hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//job details reducer

export const set_job_title_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        jobTitleInRedux: action.payload,
        // data: action.payload
      };
    case hiringManagerJobsConstants.GET_JOB_DETAILS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//job details reducer
export const get_all_added_skills_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerJobsConstants.GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allAddedSkillsData: action.payload,
      };
    case hiringManagerJobsConstants.GET_ALL_ADDED_SKILLS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
